<template>
  <Teleport to="body">
    <div v-show="open" class="consultation-drawer-backdrop" @click="$emit('close')"></div>
    <aside v-show="open" ref="panel" class="consultation-drawer" role="dialog" aria-modal="true"
           aria-labelledby="consultation-drawer-title" tabindex="-1">
      <header class="consultation-drawer__header">
        <div>
          <h2 id="consultation-drawer-title">Consulta de {{ formattedDate }}</h2>
          <p>{{ patientName }}</p>
        </div>
        <button ref="close" type="button" class="btn btn-sm btn-icon btn-light" aria-label="Fechar consulta"
                @click="$emit('close')"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
      </header>
      <div id="attendance-consultation-body" class="consultation-drawer__body"></div>
    </aside>
  </Teleport>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AttendanceConsultationDrawer',
  props: {
    open: Boolean,
    date: String,
    patientName: String,
  },
  emits: ['close'],
  computed: {
    formattedDate() { return this.date ? moment(this.date).format('DD/MM/YYYY') : ''; },
  },
  watch: {
    open(value) {
      if (value) {
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('hidden.bs.modal', this.restoreDrawerScroll);
        this.$nextTick(() => {
          this.$refs.close.focus();
          this.$refs.panel.querySelector('.consultation-drawer__body').scrollTop = 0;
        });
      } else {
        this.releaseFocus();
      }
    },
  },
  beforeUnmount() {
    if (this.open) this.releaseFocus();
  },
  methods: {
    releaseFocus() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('hidden.bs.modal', this.restoreDrawerScroll);
      document.body.style.overflow = this.previousOverflow;
      this.previousFocus?.focus();
    },
    restoreDrawerScroll() {
      if (!document.querySelector('.modal.show')) document.body.style.overflow = 'hidden';
    },
    handleKeydown(event) {
      if (document.querySelector('.modal.show, .p-dialog')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.$emit('close');
      }
      if (event.key !== 'Tab') return;
      const elements = Array.from(this.$refs.panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]'))
        .filter(element => !element.disabled && element.getClientRects().length);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>

<style scoped>
.consultation-drawer-backdrop { position: fixed; inset: 0; background: rgba(28, 22, 34, .3); z-index: 1040; }
.consultation-drawer { position: fixed; inset: 0 0 0 auto; width: min(960px, 92vw); display: flex; flex-direction: column; background: #f5f8fa; box-shadow: -8px 0 40px #21192b20; z-index: 1045; }
.consultation-drawer__header { display: flex; justify-content: space-between; align-items: center; gap: 16px; padding: 20px 24px; background: #fff; border-bottom: 1px solid #ece9ef; }
.consultation-drawer__header h2 { margin: 0; font-size: 17px; font-weight: 600; }
.consultation-drawer__header p { margin: 5px 0 0; color: #706b79; font-size: 13px; }
.consultation-drawer__body { flex: 1; min-height: 0; padding: 24px; overflow-y: auto; overscroll-behavior: contain; }
@media (max-width: 767px) {
  .consultation-drawer { width: 100%; }
  .consultation-drawer__header, .consultation-drawer__body { padding: 16px; }
}
</style>
